export default __webpack_public_path__ + "b4cc1f735c22b21fd547a5c4cdb8ba6a.mp3";